import { IconRegistryModel } from './icon-registry.interface';

export const iconsRegistry: Record<string, IconRegistryModel> = {
  alertTriangle: { id: 'alertTriangle', name: 'icon-alert_triangle' },
  analysis: { id: 'analysis', name: 'icon-analysis' },
  archive: { id: 'archive', name: 'icon-archive' },
  award: { id: 'award', name: 'icon-award' },
  badgeVerified: { id: 'badgeVerified', name: 'icon-badge_verified' },
  bolt: { id: 'bolt', name: 'icon-bolt' },
  bookmark: { id: 'bookmark', name: 'icon-bookmark' },
  calendar: { id: 'calendar', name: 'icon-calendar' },
  cart: { id: 'cart', name: 'icon-cart' },
  catering: { id: 'catering', name: 'icon-catering' },
  checkbox: { id: 'checkbox', name: 'icon-checkbox' },
  check: { id: 'check', name: 'icon-check' },
  chevronDown: { id: 'chevronDown', name: 'icon-chevron_down' },
  clock: { id: 'clock', name: 'icon-clock' },
  creditCard: { id: 'creditCard', name: 'icon-credit-card' },
  cross: { id: 'cross', name: 'icon-cross' },
  dashboard: { id: 'dashboard', name: 'icon-dashboard' },
  drink: { id: 'drink', name: 'icon-drink' },
  edit: { id: 'edit', name: 'icon-edit' },
  emojiSmile: { id: 'emojiSmile', name: 'icon-emoji_smile' },
  eye: { id: 'eye', name: 'icon-eye' },
  fileDownload: { id: 'fileDownload', name: 'icon-file_download' },
  filter: { id: 'filter', name: 'icon-filter' },
  flag: { id: 'flag', name: 'icon-flag' },
  gift: { id: 'gift', name: 'icon-gift' },
  globe: { id: 'globe', name: 'icon-globe' },
  heart: { id: 'heart', name: 'icon-heart' },
  history: { id: 'history', name: 'icon-history' },
  inbox: { id: 'inbox', name: 'icon-inbox' },
  info: { id: 'info', name: 'icon-info' },
  leaderboard: { id: 'leaderboard', name: 'icon-leaderboard' },
  lineGraphIncrease: {
    id: 'lineGraphIncrease',
    name: 'icon-line-graph_increase',
  },
  link: { id: 'link', name: 'icon-link' },
  lock: { id: 'lock', name: 'icon-lock' },
  map: { id: 'map', name: 'icon-map' },
  megaphone: { id: 'megaphone', name: 'icon-megaphone' },
  menu: { id: 'menu', name: 'icon-menu' },
  message: { id: 'message', name: 'icon-message' },
  more: { id: 'more', name: 'icon-more' },
  moreVertical: { id: 'moreVertical', name: 'icon-more_vertical' },
  payment: { id: 'payment', name: 'icon-payment' },
  personComputer: { id: 'personComputer', name: 'icon-person_computer' },
  pieChart: { id: 'pieChart', name: 'icon-pie-chart' },
  pizzaSlice: { id: 'pizzaSlice', name: 'icon-pizza-slice' },
  profile: { id: 'profile', name: 'icon-profile' },
  search: { id: 'search', name: 'icon-search' },
  search2: { id: 'search2', name: 'icon-search_2' },
  searchGlobe: { id: 'searchGlobe', name: 'icon-search_globe' },
  settings: { id: 'settings', name: 'icon-settings' },
  shoppingCart: { id: 'shoppingCart', name: 'icon-shopping-cart' },
  site: { id: 'site', name: 'icon-site' },
  sparkles: { id: 'sparkles', name: 'icon-sparkles' },
  sprout: { id: 'sprout', name: 'icon-sprout' },
  stampCard: { id: 'stampCard', name: 'icon-stamp_card' },
  star: { id: 'star', name: 'icon-star' },
  target: { id: 'target', name: 'icon-target' },
  tick: { id: 'tick', name: 'icon-tick' },
  topup: { id: 'topup', name: 'icon-topup' },
  trophy: { id: 'trophy', name: 'icon-trophy' },
  update: { id: 'update', name: 'icon-update' },
  voucher: { id: 'voucher', name: 'icon-voucher' },
} as const;
